import type {HelpFile} from '../../types/help'
import {ScopePreviewPanelTestIds} from '../../../testids/ScopePreviewPanelTestIds'

export const scopePreviewPanelHelp: HelpFile = {
    docPage: '/docs/governance/certification-policies',
    texts: {
        [ScopePreviewPanelTestIds.colPreviewIdentity]:
            'Die Identität, deren Zugriffszuweisung in den Geltungsbereich fällt.',
        [ScopePreviewPanelTestIds.colPreviewProfile]:
            'Das der Identität gewährte Zugriffsprofil (Code und Name).',
        [ScopePreviewPanelTestIds.colPreviewResource]:
            'Die geschützte Ressource, die das Zugriffsprofil gewährt.',
        [ScopePreviewPanelTestIds.colPreviewRiskLevel]:
            'Die Risikostufe der passenden Zuweisung.',
        [ScopePreviewPanelTestIds.scopePreviewPanel]: null,
        [ScopePreviewPanelTestIds.previewNoQuery]: null,
        [ScopePreviewPanelTestIds.previewLoading]: null,
        [ScopePreviewPanelTestIds.previewInScope]: null,
        [ScopePreviewPanelTestIds.previewZeroMatchWarning]: null,
        [ScopePreviewPanelTestIds.previewErrorBanner]: null,
        [ScopePreviewPanelTestIds.previewSampleCaption]: null,
        [ScopePreviewPanelTestIds.previewTooLarge]: null,
        [ScopePreviewPanelTestIds.previewFrequencyDisclaimer]: null,
        [ScopePreviewPanelTestIds.tablePreviewResults]: null,
        [ScopePreviewPanelTestIds.btnPreviewRetry]: null,
    },
}
